/* __next_internal_client_entry_do_not_use__ buildBrandReviewSummaryFromProductBrandReview,buildProductReviewSummaryFromProductBrandReview,buildBrandReviewSummaryFromBrandReviews auto */ import { localNum } from "@faire/web--source/common/localization";
/**
 * These function are used to build either brand or product review summary by
 * brandAndProductReviewSummary which has both product and brand review summary.
 */ export var buildBrandReviewSummaryFromProductBrandReview = function(brandAndProductReviewSummary) {
    if (!brandAndProductReviewSummary) {
        return undefined;
    }
    return buildReviewSummaryBase({
        numberOfReviews: brandAndProductReviewSummary.brand_total_reviews,
        overallRating: brandAndProductReviewSummary.brand_overall_rating,
        ratingDistribution: brandAndProductReviewSummary.brand_review_percentage_by_rating,
        ratingTotals: brandAndProductReviewSummary.brand_review_count_by_rating
    });
};
export var buildProductReviewSummaryFromProductBrandReview = function(brandAndProductReviewSummary) {
    if (!brandAndProductReviewSummary) {
        return undefined;
    }
    return buildReviewSummaryBase({
        numberOfReviews: brandAndProductReviewSummary.product_total_reviews,
        overallRating: brandAndProductReviewSummary.product_overall_rating,
        ratingDistribution: brandAndProductReviewSummary.product_review_percentage_by_rating,
        ratingTotals: brandAndProductReviewSummary.product_review_count_by_rating
    });
};
/**
 * This function is used to build brand review summary by IBrandReviewsSummary
 */ export var buildBrandReviewSummaryFromBrandReviews = function(brandReviewSummary) {
    if (!brandReviewSummary) {
        return undefined;
    }
    var numberOfReviews = brandReviewSummary.number_of_reviews, overallRating = brandReviewSummary.average_rating, ratingDistribution = brandReviewSummary.review_percentage_by_rating, ratingTotals = brandReviewSummary.review_count_by_rating;
    return buildReviewSummaryBase({
        numberOfReviews: numberOfReviews,
        overallRating: overallRating,
        ratingDistribution: ratingDistribution,
        ratingTotals: ratingTotals
    });
};
var buildReviewSummaryBase = function(summaryFields) {
    var numberOfReviews = summaryFields.numberOfReviews, overallRating = summaryFields.overallRating, _summaryFields_ratingDistribution = summaryFields.ratingDistribution, ratingDistribution = _summaryFields_ratingDistribution === void 0 ? {} : _summaryFields_ratingDistribution, _summaryFields_ratingTotals = summaryFields.ratingTotals, ratingTotals = _summaryFields_ratingTotals === void 0 ? {} : _summaryFields_ratingTotals;
    if (!numberOfReviews) {
        return undefined;
    }
    var _localNum;
    return {
        overallRating: overallRating !== null && overallRating !== void 0 ? overallRating : 0,
        overallRatingText: (_localNum = localNum(overallRating, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        })) !== null && _localNum !== void 0 ? _localNum : "",
        numberOfReviews: numberOfReviews !== null && numberOfReviews !== void 0 ? numberOfReviews : 0,
        reviewDistribution: Array(5).fill(0).map(function(_, i) {
            var _ratingDistribution_;
            return (_ratingDistribution_ = ratingDistribution[5 - i]) !== null && _ratingDistribution_ !== void 0 ? _ratingDistribution_ : 0;
        }),
        reviewDistributionTotals: Array(5).fill(0).map(function(_, i) {
            var _ratingTotals_;
            return (_ratingTotals_ = ratingTotals[5 - i]) !== null && _ratingTotals_ !== void 0 ? _ratingTotals_ : 0;
        })
    };
};
